import * as React from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { Label, Input } from "reactstrap";

import { UserRole, CreateCompanyInput } from "../../API";

import ErrorMessage from "../../Components/Styled/ErrorMessage";
import StyledButton from "../../Components/Styled/Button";
import Link from "../../Components/Styled/Link";
import { Col, Row } from "reactstrap";

/** Custom Types */
import { Error } from "../../CustomTypes";

import { getUsersCompany } from "src/graphql/custom-queries";
import { Colors } from "src/Themes";
import { getUserId, formatString } from "src/Utils/Helpers";
import styled from "styled-components";
import PageLoader from "src/Components/PageLoader";
import CompanyView from "../Companies/CompanyView";

import GlobalModalContainer from "../../Components/Modal";

import { ToastNotificationType } from "../../CustomTypes";

import { withToastManager } from "react-toast-notifications";
import Card from "src/Components/Styled/Card";

type Props = {
  roles?: UserRole[];
  companyData?: CreateCompanyInput | null;
  toastManager: ToastNotificationType;
  closeModal(): void;
  notification(message: string): void;
};

type State = {
  loading: boolean;
  error: Error;
  readOnly: boolean;
  modal: boolean;
  companyData: any;
};

const ToggleButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 1%;
  padding-bottom: 1%;
  align-items: center;
`;

class CompanyDetails extends React.Component<Props, State> {
  state: State = {
    loading: false,
    error: null,
    readOnly: true,
    modal: false,
    companyData: {}
  };

  /** Error */
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  openEdit = (data: object) => {
    this.setState({ modal: true, companyData: data });
  };

  /** Close modal */
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  returnFormFields = (data: any) => {
    const {
      name,
      emailAddress,
      address,
      province,
      contactNumber,
      numberOfEmployees,
      // physicalAddress,
      industry
    } = data;
    const { error, readOnly } = this.state;
    return (
      <React.Fragment>
        <Row style={{ paddingTop: "20px", width: "100%" }}>
          <Col sm={12} md={12} lg={12} style={{ paddingTop: "20px" }}>
            <h3>Company Account Details</h3>
          </Col>
          <Col sm={12} md={12} lg={12}>
            <ToggleButtonsContainer>
              <Link
                to={{
                  pathname: "/consumer/team",
                  params: {
                    containerTitle: name + " Team members",
                    companyData: data
                  }
                }}
                label={
                  <StyledButton
                    type="button"
                    label="View Team"
                    width="100px"
                    color={Colors.snow}
                    background={Colors.default}
                  />
                }
              />
              <StyledButton
                type="button"
                label="Edit"
                width="100px"
                onClick={() => this.openEdit(data)}
                color={Colors.coal}
                background={Colors.background}
              />
            </ToggleButtonsContainer>
          </Col>
          <Card width={"100%"}>
            <Row>
              <Col sm={12} md={6} lg={6}>
                <Label for="name">Name</Label>
                <Input
                  type="text"
                  name="name"
                  value={name}
                  id="name"
                  placeholder="Name"
                  disabled={readOnly}
                />
                <br />
                <Label for="emailAddress">Email Address</Label>
                <Input
                  type="email"
                  name="emailAddress"
                  value={emailAddress}
                  id="emailAddress"
                  placeholder="Email Address"
                  disabled={readOnly}
                />
                <br />
                <Label for="contactNumber">Contact Number</Label>
                <Input
                  type="number"
                  name="contactNumber"
                  value={contactNumber}
                  id="contactNumber"
                  placeholder="Contact Number"
                  disabled={readOnly}
                />
                <br />
                <Label for="industry">Industry</Label>
                <Input
                  type="text"
                  name="industry"
                  value={formatString(industry) || ""}
                  id="industry"
                  placeholder="Industry"
                  disabled={readOnly}
                />
              </Col>
              <Col sm={12} md={6} lg={6}>
                <Label for="address">Address</Label>
                <Input
                  type="text"
                  name="address"
                  value={address}
                  id="address"
                  placeholder="ID number"
                  disabled={readOnly}
                />
                {/* <br />
                <Label for="physicalAddress">Address Line 2</Label>
                <Input
                  type="text"
                  name="physicalAddress"
                  value={physicalAddress}
                  id="physicalAddress"
                  placeholder="Address Line 2"
                  disabled={readOnly}
                /> */}
                <br />
                <Label for="province">Province</Label>
                <Input
                  type="text"
                  name="province"
                  value={formatString(province) || ""}
                  id="province"
                  disabled={readOnly}
                />
                <br />
                <Label for="numberOfEmployees">Number of Employees</Label>
                <Input
                  type="text"
                  name="numberOfEmployees"
                  value={numberOfEmployees}
                  id="numberOfEmployees"
                  placeholder="Number of Employees"
                  disabled={readOnly}
                />
              </Col>
            </Row>
          </Card>
          {error && <ErrorMessage errorMessage={error} />}
        </Row>
      </React.Fragment>
    );
  };

  /** Success notification */
  toastNotification = (message: string, appearance?: string) => {
    this.props.toastManager.add(message, {
      appearance: appearance ? appearance : "success",
      autoDismiss: true
    });
  };

  render() {
    return (
      <React.Fragment>
        <GlobalModalContainer
          toggleModal={this.closeModal}
          title="Edit Company Details"
          modalDisplay={
            <CompanyView
              roles={[UserRole.ROOTS_SUPER_ADMIN, UserRole.ROOTS_ADMIN]}
              notification={this.toastNotification}
              closeModal={this.closeModal}
              companyData={this.state.companyData}
              editCompany={true}
              {...this.props}
            />
          }
          modal={this.state.modal}
        />
        <Query query={gql(getUsersCompany)} variables={{ id: getUserId() }}>
          {({ loading, error, data }) => {
            if (loading) {
              return <PageLoader />;
            }
            if (error) {
              return <div>There was a problem loading your data</div>;
            }

            if (
              !data ||
              !data.getUser ||
              !data.getUser.company.items ||
              !data.getUser.company.items[0].company
            ) {
              return <div>Cannot retreive company data</div>;
            }
            return this.returnFormFields(data.getUser.company.items[0].company);
          }}
        </Query>
      </React.Fragment>
    );
  }
}

export default withToastManager(CompanyDetails);



// WEBPACK FOOTER //
// ./src/Containers/Consumer/CompanyDetails.tsx